import { listingReducer } from "../reducers/utils/listingReducer";
import { getBlogList } from "../../services/Blogs";

const { reducer, actions, types } = listingReducer({
  name: `blogs`,
  getApi: getBlogList,
});
const blogs = reducer;
export { blogs, actions, types };
